module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyrightPage",
    attrs: {
      "id": "cop01"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagevi"
    }
  }, [_c('p', {
    staticClass: "copyrightText"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/crlogo1.jpg"
    }
  }), _c('br'), _vm._v("A Division of Simon & Schuster, Inc."), _c('br'), _vm._v(" 1230 Avenue of the Americas"), _c('br'), _vm._v(" New York, NY 10020")])]), _c('p', {
    staticClass: "copyrightText"
  }, [_c('a', {
    attrs: {
      "id": "pagevi"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/crlogo2.jpg"
    }
  }), _c('br'), _vm._v("20827 N.W. Cornell Road, Suite 500"), _c('br'), _vm._v(" Hillsboro, Oregon 97124-9808"), _c('br'), _vm._v(" 503-531-8700 / 503-531-8773"), _c('br'), _vm._v(" fax "), _c('span', {
    staticClass: "xrefURL"
  })]), _c('a', {
    attrs: {
      "href": "http://www.beyondword.com",
      "target": "_blank"
    }
  }, [_vm._v("www.beyondword.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Copyright © 2005, 2008 by Mike Dooley")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever without the prior written permission of Atria Books/Beyond Words Publishing, Inc., except where permitted by law.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ATRIA")])]), _vm._v(" "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("BOOKS")]), _vm._v(" and colophon are trademarks of Simon & Schuster, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Beyond Words Publishing is a division of Simon & Schuster, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Dooley, Mike.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Even more notes from the universe: dancing life’s dance / Mike Dooley."), _c('br'), _vm._v(" p. cm."), _c('br'), _vm._v(" 1. Self-help techniques—Miscellanea. 2. Spirituality—Miscellanea. 3. Occultism—Miscellanea. I. Title."), _c('br'), _vm._v(" BF1999.D61551      2008"), _c('br'), _vm._v(" 158—dc22           2008017876")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("ISBN-13: 978-1-4165-9416-1"), _c('br'), _vm._v("ISBN-10: 1-4165-9416-7")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("The corporate mission of Beyond Words Publishing, Inc.: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Inspire to Integrity")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Visit us on the World Wide Web: "), _c('br'), _c('span', {
    staticClass: "xrefURL"
  }, [_c('a', {
    attrs: {
      "href": "http://www.SimonSays.com",
      "target": "_blank"
    }
  }, [_vm._v("http://www.SimonSays.com")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d09afd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781416594161_cop01.vue
// module id = 69
// module chunks = 0